module.exports = __webpack_public_path__ + "static/rohit-bw@2x-206fd46546501aaa0cb37f6a67bf49a0.png";